export const PROJECT = "starcoin";